// The ONE definition of "an EORI the declaration accepts": two letters + 5-15 letters/digits (after trim + upper-case).
// Used by the pre-submit check (submit-ecustoms/precheck.ts, which blocks the declaration) and by the job screens that warn about the same
// value (src/lib/partyTaxStatus.ts), so what the screen calls valid is exactly what the check lets through.
export const EORI_RE = /^[A-Z]{2}[A-Z0-9]{5,15}$/
